// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"styles_spinnerWrapper__uC0Ti"};